import React from 'react';

import {Poll, Chat, ReactionTriggers} from 'Components/MainStage';

import {translation} from 'Services/TranslationHelpers';

import Base from './Base';

export default class Remote extends Base {
    /**
     * @var success
     * @type {boolean}
     */
    remote_control = true;

    /**
     * @var state
     */
    state = {
        working: false,
        sessions: null,
        currentSession: null,
        currentPoll: null,
        tab: null,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
    };

    /**
     * @method handleSetTab
     * @param {string} tab
     */
    handleSetTab = (tab) => {
        this.setState({
            tab
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {currentSession, tab} = this.state;

        return (
            <div className="h-screen w-screen">
                {currentSession && (
                    <React.Fragment>
                        <div className="h-5/6">
                            {tab === null && this.renderNoTab()}
                            {tab === 'chat' && this.renderChat()}
                            {tab === 'reactions' && this.renderReactions()}
                            {tab === 'polls' && this.renderPolls()}
                        </div>

                        <div className="h-1/6 flex">
                            {currentSession.chat && this.renderButton(translation('main_stage_frontend', 'chat_tab_text'), 'chat')}
                            {currentSession.reactions && this.renderButton(translation('main_stage_frontend', 'reactions_tab_text'), 'reactions')}
                            {currentSession?.polls_enabled && this.renderButton(translation('main_stage_frontend', 'polls_tab_text'), 'polls')}
                        </div>
                    </React.Fragment>
                )}

                {!currentSession && (
                    <div className="h-full w-full flex justify-center items-center">
                        <p>{translation('main_stage_frontend', 'no_sessions_running')}</p>
                    </div>
                )}
            </div>
        );
    }

    /**
     * @method renderNoTab
     * @returns {JSX.Element}
     */
    renderNoTab = () => {
        return (
            <div className="h-full w-full flex justify-center items-center bg-app-blue text-white">
                {translation('main_stage_frontend', 'select_tab_get_started')}
            </div>
        );
    };

    /**
     * @method renderChats
     * @return {JSX.Element}
     */
    renderChat = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full flex justify-center items-center">
                <Chat
                    sessionId={currentSession?.id}
                />
            </div>
        );
    };

    /**
     * @method renderReactions
     * @return {JSX.Element}
     */
    renderReactions = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full px-8 flex justify-between items-center bg-app-blue">
                <ReactionTriggers
                    source="remote-control"
                    sessionId={currentSession?.id}
                />
            </div>
        );
    };

    /**
     * @method renderPolls
     * @return {JSX.Element}
     */
    renderPolls = () => {
        const {currentPoll, currentSession} = this.state;

        if (!currentPoll) {
            return (
                <div className="h-full w-full flex justify-center items-center">
                    {translation('main_stage_frontend', 'no_polls')}
                </div>
            );
        }

        return (
            <div className="h-full w-full flex justify-center items-center">
                <Poll
                    poll={currentPoll}
                    sessionId={currentSession.id}
                />
            </div>
        );
    };

    /**
     * @method renderButton
     * @param {string} text
     * @param {string} tab
     * @return {JSX.Element}
     */
    renderButton = (text, tab) => {
        const {tab: activeTab} = this.state;

        return (
            <button
                className={`w-full h-full border-r border-t border-gray-200 ${activeTab === tab ? 'bg-app-blue-light text-white' : 'bg-white'}`}
                onClick={() => this.handleSetTab(tab)}
            >
                {text}
            </button>
        );
    };
}
